import React from "react";
import styled from "styled-components";
import { useNavigate, useLocation } from "react-router";
import { ReactComponent as LeftArrow } from "../../assets/icons/LeftArrow.svg";
import { ReactComponent as MobileLeft } from "../../assets/icons/MobileArrow.svg";
import Logo from "../../components/molecures/Logo";
import RegisterForm from "./components/RegisterForm";
import { MIN_MORNITOR_WIDTH } from "../../components/constants";
import MainContainer from "../../components/atoms/MainContainer";
import MainContentContainer from "../../components/atoms/MainContentContainer";
import { theme } from "../../theme";
import { PATH } from "../../routes/constants/path";

const ReRegister: React.FC = () => {
  const nav = useNavigate();
  const location = useLocation();
  const sch = location.search;
  const params = new URLSearchParams(sch);
  const keyword = params.get("isApp");
  const handleClick = () => {
    const sch = location.search;
    const params = new URLSearchParams(sch);
    const keyword = params.get("isApp");
    if (keyword !== "true") nav(PATH.LOGIN);
  };
  return (
    <MainContainer>
      <Logo />

      <MainContentContainer>
        <NavWrapper>
          <NavTextWrapper>
            {keyword !== "true" && (
              <NavIcon onClick={handleClick}>
                <LeftArrow />
              </NavIcon>
            )}

            {keyword !== "true" && (
              <MobileNavIcon onClick={handleClick}>
                <MobileLeft />
              </MobileNavIcon>
            )}
            <NavText onClick={handleClick}>제휴 신청하기</NavText>
          </NavTextWrapper>
        </NavWrapper>

        <RegisterForm />
      </MainContentContainer>
    </MainContainer>
  );
};
export default ReRegister;
const NavWrapper = styled.div`
  margin: 60px 0px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;

  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    max-width: 100%;
    margin: 0px;
    min-height: 56px;
    padding: 0px;
    justify-content: center;
    align-items: center;
    background-color: ${theme.colors.white};
  }
`;
const NavTextWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  max-width: 700px;
  width: 100%;
  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    max-width: none;
    min-width: none;
    justify-content: flex-start;
  }
`;
const NavIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
  cursor: pointer;
  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    display: none;
  }
`;
const MobileNavIcon = styled.div`
  display: none;
  padding-left: 24px;
  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
const NavText = styled.div`
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 48px;
  letter-spacing: 0em;
  text-align: left;
  cursor: pointer;
  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    ${theme.typo.heading.b18};
    max-width: 100vw;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0em;
    height: 24px;
    margin-left: 32px;
    text-align: center;
    color: ${theme.colors.gray1};
  }
`;
